<template>
  <div class="container">
    <div class="mwow-top-title">
      <span class="text">积分控制</span>
    </div>
    <el-form class="mwow-wrap" size="mini">
      <el-form-item label="积分功能">
        <el-switch
          v-model="integralOpen"
          @change="toggleMainSwitch"
        ></el-switch>
        <div
          :class="`mwow-button-filled ${integralOpen ? 'primary' : 'disable'}`"
          style="margin-left: 24px"
          @click="showTimeoutDialog"
        >
          积分设置
        </div>
      </el-form-item>
    </el-form>
    <div v-if="integralOpen">
      <p class="main-title-wrap">
        积分获得途径<span class="yellow"
          >（以下为学员自动获得积分途径；门店可依据实际情况自由设置分值）</span
        >
      </p>
      <el-table
        size="mini"
        v-horizontal-scroll
        :data="tableData"
        stripe
        style="width: 100%"
        tooltip-effect="dark"
      >
        <el-table-column label="分值开关" prop="status">
          <template slot-scope="scope">
            <el-switch
              v-model="scope.row.status"
              @change="toggleTaskSwitch(scope.row)"
            ></el-switch>
          </template>
        </el-table-column>
        <el-table-column label="积分类型" prop="task_title"></el-table-column>
        <el-table-column label="积分分值" prop="integral">
          <template slot-scope="scope">
            <integral-editor
              type="course"
              :task-key="scope.row.task_key"
              :ori="scope.row.integral"
            ></integral-editor>
          </template>
        </el-table-column>
        <el-table-column label="积分说明" prop="explain"></el-table-column>
      </el-table>
    </div>
    <div class="no-data" v-else>
      <img
        class="person"
        src="https://wowsite.musicwow.com/teaching_system_frontend/images/integral/no-data.png"
        width="101"
        height="154"
      />
      <img
        class="line"
        src="https://wowsite.musicwow.com/teaching_system_frontend/images/integral/no-data-line.png"
        width="284"
        height="96"
      />
      <p class="text">积分功能暂未开启</p>
    </div>
    <!-- 过期弹窗 -->
    <el-dialog
      :visible.sync="timeoutDialogVisible"
      title="积分设置"
      append-to-body
      destroy-on-close
    >
      <div class="timeout-dialog-content">
        <p class="top-text">
          默认开启，到达下一年1月1日凌晨1点时，所有学员积分自动清零；<br />可选择关闭过期开关，关闭后学员积分永久有效。
        </p>
        <div class="switch-wrap mwow-form">
          <span class="dot">*</span>
          <p class="text">积分过期：</p>
          <el-switch v-model="timeoutSwitch"></el-switch>
        </div>
        <p class="bottom-text">
          注意：关闭后开启，会自动检查当前年份，默认将过期时间更新至下一年的1月1日凌晨1点；<br />跨年时关闭后开启，会延长积分过期时间；
        </p>
        <div class="button-wrap">
          <div class="button mwow-button" @click="handleCloseTimeoutDialog">
            取消
          </div>
          <div
            class="button mwow-button-filled success mini"
            @click="handleTimeoutSwitchChange"
          >
            保存
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  orgIntegralSwitchApi,
  getIntegralSettingApi,
  setIntegralTaskStatusApi,
} from "@/api/integral";
import { UserModule } from "@/store/module/user";
import { switchDetailApi, switchModifyApi } from "@/api/storeManagement";
import integralEditor from "./integralEditor.vue";

export default {
  name: "integralSetting",
  components: {
    integralEditor,
  },
  data() {
    return {
      integralOpen: true,
      tableData: [],
      logSource: {},
      timeoutDialogVisible: false,
      timeoutSwitch: false,
    };
  },
  created() {
    this.getList();
  },
  methods: {
    getList() {
      getIntegralSettingApi().then((res) => {
        res.data.task.map((item) => {
          item.status = item.status === 1;
        });
        // this.tableData = res.data.task.filter((item) => {
        //   // // 隐藏点名签到奖励(roll_call_task)
        //   // if (item.task_key !== "roll_call_task") {
        //   //   return item;
        //   // }
        //   return item;
        // });
        this.tableData = res.data.task;
        this.integralOpen = res.data.integral_switch === 1;
      });
    },
    toggleMainSwitch(v) {
      if (!v) {
        this.$confirm(
          "关闭后，门店所有与积分相关的功能全部不可使用。确定要关闭积分功能？",
          `关闭 - 积分功能`,
          {
            confirmButtonText: "确定",
            confirmButtonClass: "mwow-button-filled success mini",
            cancelButtonText: "取消",
            cancelButtonClass: "mwow-button-filled mini",
            iconClass: "mwow-icon-error",
          }
        )
          .then(() => {
            const params = {
              key: "integral_switch",
              status: v ? 1 : 2,
            };
            orgIntegralSwitchApi(params)
              .then(() => {
                this.getList();
                UserModule.updateUserInfo();
              })
              .catch(() => {
                this.getList();
              });
          })
          .catch(() => {
            this.getList();
          });
      } else {
        const params = {
          key: "integral_switch",
          status: v ? 1 : 2,
        };
        orgIntegralSwitchApi(params)
          .then(() => {
            this.getList();
            UserModule.updateUserInfo();
          })
          .catch(() => {
            this.getList();
          });
      }
    },
    toggleTaskSwitch(row) {
      const params = {
        task_key: row.task_key,
        status: row.status ? 1 : 2,
      };
      setIntegralTaskStatusApi(params)
        .then(() => {
          this.getList();
        })
        .catch(() => {
          this.getList();
        });
    },
    showTimeoutDialog() {
      if (!this.integralOpen) {
        return false;
      }
      switchDetailApi().then((res) => {
        this.timeoutSwitch = res.data.integral_expire === 1;
      });
      this.timeoutDialogVisible = true;
    },
    handleTimeoutSwitchChange() {
      switchModifyApi({
        key: "integral_expire",
        status: this.timeoutSwitch ? 1 : 2,
      }).then(() => {
        this.$message({
          type: "success",
          message: "保存成功",
        });
        this.timeoutDialogVisible = false;
      });
    },
    handleCloseTimeoutDialog() {
      this.timeoutDialogVisible = false;
    },
  },
};
</script>
<style lang="scss" scoped>
.container {
  background-color: #ffffff;
  padding: 0 12px 12px 12px;
  border-radius: 4px;
  overflow: hidden;
}
.main-title-wrap {
  font-size: 14px;
  color: #5c5d5e;
  font-weight: bold;
  margin-bottom: 20px;
  .yellow {
    font-size: 12px;
    color: #ffb940;
  }
}
.no-data {
  position: relative;
  min-height: 500px;
  .line {
    position: absolute;
    top: 75px;
    left: 50%;
    margin-left: -380px;
  }
  .person {
    position: absolute;
    top: 141px;
    left: 50%;
    margin-left: -50px;
  }
  .text {
    font-size: 12px;
    color: #5c5d5e;
    position: absolute;
    top: 305px;
    left: 50%;
    margin-left: -56px;
  }
}
.timeout-dialog-content {
  .top-text {
    font-size: 14px;
    line-height: 18px;
    color: #5c5d5e;
    margin-bottom: 24px;
  }
  .switch-wrap {
    display: flex;
    align-items: center;
    margin-bottom: 24px;
    .dot {
      font-size: 14px;
      color: #f56c6c;
    }
    .text {
      font-size: 14px;
      color: #5c5d5e;
    }
  }
  .bottom-text {
    font-size: 14px;
    line-height: 18px;
    color: #ffb940;
    margin-bottom: 24px;
  }
  .button-wrap {
    border-top: 1px solid #e1e5e9;
    padding-top: 16px;
    text-align: right;
    .button {
      margin-left: 12px;
    }
  }
}
</style>
